export const ORDER_TRNSYS_FIRST = 'ORDER_TRNSYS_FIRST'
export const ORDER_TRNSYS_UPDATE = 'ORDER_TRNSYS_UPDATE'
export const ORDER_ADDONS = 'ORDER_ADDONS'
export const ORDER_SUPPORT = 'ORDER_SUPPORT'
